export default __webpack_public_path__ + "static/media/timg.b4c647bf.jpg";